<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-flex xs12>
                <v-dialog v-model="dialogVisible" width="500">
                    <v-card dark>
                        <v-card-text>
                            <note-edit-component v-model="note" @submit="store"/>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-flex>
            <DataTable
                    :url="url" ref="datatable" :enable-delete="false" descending :sortable="false"
                    :enable-edit="false" :key="update" :enable-add="false" disable-search
                    :conditional-action="conditionalActions"
                    :actions-extra-main="actions"
                    :title="false" :titles="notes"
                    :fields-hidden-main="['updated_at','subject_id','subject_type','author_type','author_id','subject']"
                    :formatter="formatters"></DataTable>
        </v-container>
        <v-btn @click="dialogVisible=true" color="#55ddb2" style="position:fixed;right: 0;bottom: 0;" fab
               :loading="loading">
            <v-icon>note_add</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import DataTable from '@/components/wasilni/DataTable';
    import NoteEditComponent from "@/components/NoteEditorComponent";
    import VWidget from "@/components/VWidget";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "notes",
        components: {LoadingComponent, DataTable, NoteEditComponent, VWidget},
        props: ['provider', 'id'],
        data() {
            return {
                url: 'note',
                notes: {
                    id: 'ID',
                    note: "Note",
                    author: "Author",
                    expiry_date: 'Expiry Date',
                    created_at: 'Created At',
                },
                note: {},
                update: 0,
                loading: false,
                dialogVisible: false,
                formatters: {
                    author(value) {
                        return `${value.first_name} ${value.last_name} (${value.username})`
                    },
                    expiry_date(value) {
                        if (!value) return "For Ever";
                        return (new Date(value)).toLocaleDateString();
                    },
                    created_at(value) {
                        return (new Date(value)).toLocaleString()
                    }
                },
            };
        },
        computed: {
            actions() {
                return {
                    solve: {
                        title: 'solve',
                        action: async (item) => {
                            this.loading = true;
                            this.axios.put(this.api.ACTIONS.NOTES + '/' + item.id)
                                .then(
                                    () => {
                                        item.status = 'SOLVED';
                                        window.getApp.$emit("SHOW_TOAST", "SOLVED", "GREEN");
                                    }
                                )
                                .catch(
                                    ({response}) => {
                                        console.log(response);
                                        window.getApp.$emit("SHOW_TOAST", "COULDN'T SOLVED (CHECK ERROR LOG)", "RED");
                                    }
                                )
                                .finally(
                                    () => this.loading = false
                                )
                        }
                    }
                }
            },
            conditionalActions() {
                return {
                    solve({status}) {
                        return status === 'NEEDS_SOLVING';
                    }
                }
            },
        },
        mounted() {
            this.url += `?subject_type=${this.provider}&subject_id=${this.id}`;
        },
        methods: {
            store() {
                this.loading = true;
                this.dialogVisible = false;
                this.axios.post('note', Object.assign({}, this.note, {
                    subject_type: this.provider,
                    subject_id: this.id
                })).then(res => {
                    this.loading = false;
                    this.$refs.datatable.addItemToTable(res.data.data);
                    window.getApp.$emit('SHOW_TOAST', 'SENT', 'green');
                }).catch(err => console.log(err.message));
            }
        }
    }
</script>

<style scoped>

</style>